import styled, { css } from 'styled-components';
import NextImage from 'next/image';

import QuoteIcon from 'Public/graphics/icons/big-quote-mark.svg';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        width: 100%;
        position: relative;
        overflow: hidden;
        font-family: ${theme.fonts.secondary};
        padding: 1rem 0;

        @media ${theme.breakpoints.large.media} {
            padding: 2rem 0;
        }
    `}
`;

export const Background = styled.div`
    ${({ theme }) => css`
        height: 100%;
        position: absolute;
        z-index: 0;
        left: -20rem;
        bottom: 0;
        top: -1rem;
        transform: rotate(10deg);

        @media ${theme.breakpoints.medium.media} {
            left: 0;
            top: 0;
            transform: rotate(0);
            display: flex;
            align-items: center;
        }
    `}
`;

export const WaveImage = styled(NextImage)`
    ${({ theme }) => css`
        height: 13.0625rem;
        width: auto;

        @media ${theme.breakpoints.large.media} {
            height: 18.875rem;
            width: 90.375rem;
        }
    `}
`;

export const Container = styled.figure`
    ${({ theme }) => css`
        display: flex;
        margin: 3rem 1rem 0 1rem;

        @media ${theme.breakpoints.medium.media} {
            margin: 0 0 0 40%;
            min-height: 13.5625rem;
            align-items: center;
        }

        @media ${theme.breakpoints.large.media} {
            min-height: 18.875rem;
        }
    `}
`;

export const ImageContainer = styled.div`
    position: relative;
`;

export const ImageWrapper = styled.div<{ $quoteColor?: string; $avatarBackgroundColor?: string }>`
    ${({ theme, $quoteColor, $avatarBackgroundColor }) => css`
        min-height: 7.5rem;
        min-width: 7.5rem;
        position: relative;
        overflow: hidden;
        border-radius: 50%;
        border: 0.25rem solid ${$quoteColor};
        background-color: ${$avatarBackgroundColor};

        @media ${theme.breakpoints.large.media} {
            min-height: 9.875rem;
            min-width: 9.875rem;
        }
    `}
`;

export const LeftQuoteIcon = styled(QuoteIcon)<{ $quoteColor?: string }>`
    ${({ theme, $quoteColor }) => css`
        position: absolute;
        top: -2.5rem;
        left: 3rem;
        transform: scale(0.7);
        z-index: 2;

        @media ${theme.breakpoints.large.media} {
            width: 6.125rem;
            height: 4.0625rem;
            top: -3rem;
            left: 5rem;
            transform: scale(1);
        }

        > path {
            fill: ${$quoteColor};
        }
    `}
`;

export const QuoteWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Blockquote = styled.blockquote`
    margin: 0 0 0 1.5rem;
`;

export const Quote = styled.p<{ $quoteColor?: string }>`
    ${({ theme, $quoteColor }) => css`
        margin: 0;
        z-index: 1;
        line-height: 1.25;
        font-size: 1.25rem;
        color: ${$quoteColor};

        @media ${theme.breakpoints.large.media} {
            font-size: 2rem;
        }
    `}
`;
